import "./index.scss";

const Topography = (props: any) => {
  const { children } = props;
  return <h6 className="custom__topography">{children}</h6>;
};

export default Topography;
